"use client";

import { createTheme } from "@mui/material/styles";
import { colors } from "./themeTokens";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: colors.accent.primary,
      light: colors.accent.primaryLight,
      contrastText: "#ffffff",
    },
    secondary: {
      main: colors.accent.secondary,
      contrastText: "#000000",
    },
    error: {
      main: colors.accent.error,
    },
    success: {
      main: colors.accent.success,
    },
    background: {
      default: colors.background.default,
      paper: colors.background.paper,
      overlay: colors.background.overlay,
      hover: colors.background.hover,
      listItem: colors.background.listItem,
      buttonOverlay: colors.background.buttonOverlay,
      transparent: colors.background.transparent,
      section: colors.background.section,
      accent: colors.background.accent,
    },
    text: {
      primary: colors.text.primary,
      secondary: colors.text.secondary,
      disabled: colors.text.disabled,
      muted: colors.text.muted,
      subtle: colors.text.subtle,
      inverse: colors.text.inverse,
      link: colors.text.link,
    },
    divider: colors.border.default,
  },
  typography: {
    fontFamily: 'var(--font-inter), "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      letterSpacing: "-0.02em",
    },
    h2: {
      fontWeight: 600,
      letterSpacing: "-0.01em",
    },
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 600,
    },
    body1: {
      lineHeight: 1.7,
    },
    body2: {
      lineHeight: 1.6,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: "8px",
          fontWeight: 500,
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: colors.background.default,
          color: colors.text.primary,
        },
      },
    },
  },
});

export default theme;
